import {IVanillaReaderUiComponentController} from "./IVanillaReaderUiComponentController";
import {IVanillaReaderUI} from "./IVanillaReaderUI";
import {VanillaReaderUI} from "./VanillaReaderUI";

export interface VanillaReaderUiLabelPageNumberController extends IVanillaReaderUiComponentController, IVanillaReaderUI {}

/**
 * # VanillaReaderUiLabelPageNumberController
 *
 * ## RESPONSIBILITIES
 * This controller mixing class handles all event callbacks from the `VanillaReaderUiLabelPageNumber` class.
 *
 * Just as all other controller mixin classes, this class is used to add functionality to the `VanillaReaderUi` class
 * in a "modular" way. Read more about this in the `UI Components and Controller Mixins` in the README.md file.
 *
 * ## RELATED TYPES
 * - VanillaReaderUi
 *
 * */
export class VanillaReaderUiLabelPageNumberController {
    static __initialize__(vanillaReaderUiContext: VanillaReaderUI): void {
        vanillaReaderUiContext.labelPageNumber.onClick(vanillaReaderUiContext._onLabelPageNumberClick.bind(vanillaReaderUiContext));
    }

    _onLabelPageNumberClick(): void {
        this.togglePageNumbers();
    };

}
